import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var LariSign = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 384 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M144 32c17.7 0 32 14.3 32 32v32.7c5.3-.4 10.6-.7 16-.7s10.7.2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2 3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3v68c0 17.7-14.3 32-32 32s-32-14.3-32-32v-95c-5.2-.7-10.6-1-16-1s-10.8.3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32v-67.9C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h16.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
  }));
});
LariSign.displayName = 'LariSign';
export var LariSignDimensions = {
  height: 512,
  width: 384
};